/* src/app/components/payroll/invoices/staff/invoices-staff-list/invoice-edit-history-view/invoice-edit-history-view.component.css */
.expand-row-icon-btn {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
.table-header-main {
  font-weight: bold;
  font-size: 14px;
  color: black;
}
.edit-history-content {
  border: 1px solid #1c1b1b !important;
  margin: 16px 10px !important;
  border-radius: 4px !important;
}
.action-container {
  padding-left: 0px !important;
}
/*# sourceMappingURL=invoice-edit-history-view.component-NFCHTOIC.css.map */
